import moment, { Moment } from 'moment';

export class MomentHelper {
    static readonly FRENCH_DATE_FORMAT = 'DD/MM/YYYY';
    static readonly FRENCH_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
    static readonly ISO_8601_DATE_FORMAT: string = 'YYYY-MM-DD';
    static readonly ISO_8601_DATETIME_FORMAT: string = 'YYYY-MM-DD HH:mm:ss';

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Formatte la date specifiée au format français (dd/MM/YYYY).
     * @param date : La date à formatter.
     * @returns : La date formattée.
     */
    public static formatAsFrenchDate(date: Moment): string {
        return date.format(MomentHelper.FRENCH_DATE_FORMAT);
    }

    /**
     * Formatte la date specifiée au format français (dd/MM/YYYY).
     * @param date : La date à formatter.
     * @returns : La date formattée.
     */
    public static formatAsFrenchDateTime(date: Moment): string {
        return date.format(MomentHelper.FRENCH_DATETIME_FORMAT);
    }

    /**
     * Formatte la date specifiée au format ISO-8601 (yyyy-MM-dd).
     * @param date : La date à formatter.
     * @returns : La date formattée.
     */
    public static formatAsIso8601Date(date: Moment): string {
        return date.format(MomentHelper.ISO_8601_DATE_FORMAT);
    }

    /**
     * Formatte la date specifiée au format ISO-8601 avec heure (yyyy-MM-ddTHH:mm:ss.SSS).
     * @param date : La date à formatter.
     * @returns : La date formattée.
     */
    public static formatAsIso8601DateTime(date: Moment): string {
        return date.format(MomentHelper.ISO_8601_DATETIME_FORMAT);
    }

    /**
     * Parse une chaîne de caractères contenant une date avec des heures au format français pour créer une instance de Moment.
     * @param value Chaîne de caractères contenant la date.
     * @returns Une instance de Moment.
     */
    public static parseFrenchDateTime(value: string): Moment {
        return moment(value, MomentHelper.FRENCH_DATETIME_FORMAT);
    }
}
